import { TableSizeTheme } from './types';

export const TABLE_SIZES = {
  LARGE: 'LARGE',
  MEDIUM: 'MEDIUM',
  SMALL: 'SMALL',
} as const;

export const TABLE_SIZE_THEMES: Record<
  keyof typeof TABLE_SIZES,
  TableSizeTheme
> = {
  [TABLE_SIZES.LARGE]: {
    size: TABLE_SIZES.LARGE,
    rowHeight: 64,
    cellPadding: 16,
    iconCellWidth: 52,
  },
  [TABLE_SIZES.MEDIUM]: {
    size: TABLE_SIZES.MEDIUM,
    rowHeight: 48,
    cellPadding: 16,
    iconCellWidth: 52,
  },
  [TABLE_SIZES.SMALL]: {
    size: TABLE_SIZES.SMALL,
    rowHeight: 36,
    cellPadding: 8,
    iconCellWidth: 44,
  },
} as const;

export const STICKY_TYPES = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export const DEFAULT_TABLE_SIZE = TABLE_SIZES.MEDIUM;

export const SORT_DIRECTIONS = { ASC: 'asc', DESC: 'desc' };

export const TABLE_ROW_SELECTED_CLASSNAME = 'TableRow__selected';

export const TABLE_ROW_SELECTABLE_CLASSNAME = 'TableRow__selectable';

export const TABLE_CELL_SELECTOR = 'td, th';
export const TABLE_FOCUSABLE_CELL_SELECTOR =
  'td:not([tabindex="-1"]), th:not([tabindex="-1"])';
export const TABLE_ROW_SELECTOR = 'tr';
export const TABLE_FOCUSABLE_ROW_SELECTOR = 'tr:not([tabindex="-1"])';
export const TABLE_ROW_GROUP_SELECTOR = 'thead, tbody, tfoot';

export const TABLE_FOCUSABLE_SELECTOR =
  'a, frame, iframe, input:not([type=hidden]):not(:disabled), select:not(:disabled), textarea:not(:disabled), button:not([aria-disabled="true"]):not([tabindex="-1"]):not(:disabled), *[tabindex]';

export enum Keys {
  Enter = 'Enter',
  Escape = 'Escape',
  Tab = 'Tab',
  ArrowLeft = 'ArrowLeft',
  ArrowUp = 'ArrowUp',
  ArrowRight = 'ArrowRight',
  ArrowDown = 'ArrowDown',
}
